import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Partnersec from '../Components/Partnersec/Partnersec'
import img from '../assets/others/11102062.png'
import { Helmet } from 'react-helmet-async'

const Registernow = () => {
  return (
    <div>
        <Helmet>
          <title>Register Now for VLSI Training Batches Today | Takshila VLSI</title>
            <meta name="description" content="Register for upcoming VLSI training batches and take the next step toward a semiconductor design career with job-oriented courses and practical training from Takshila VLSI." />
            <link rel="canonical" href="https://www.takshila-vlsi.com/register-now/" />

            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Register Now for VLSI Training Batches Today | Takshila VLSI" />
            <meta property="og:description" content="Register for upcoming VLSI training batches and take the next step toward a semiconductor design career with job-oriented courses and practical training from Takshila VLSI." />
            <meta property="og:url" content="https://www.takshila-vlsi.com/register-now/" />
            <meta property="og:site_name" content="Takshila VLSI" />
            <meta property="article:modified_time" content="2024-11-28T13:11:44+00:00" />
            <meta property="og:image" content="https://www.takshila-vlsi.com/wp-content/uploads/2019/10/UVM-Training-Online.jpg" />
            <meta property="og:image:width" content="1000" />
            <meta property="og:image:height" content="667" />
            <meta property="og:image:type" content="image/jpeg" />
            <meta name="twitter:card" content="summary_large_image" />
          </Helmet>
    <Header/>  
    <main>
    <section className='section-banner pg-banner mb-5'>
            <div class="container text-center">
                          <div class="row justify-content-around ">
                              <div class="col-md p-5">
                                <div class="pg-title-sec">
                                    <h1 className='pg-title pb-3'>REGISTER NOW
                                    </h1>
                                 </div>
                              </div>
                          </div>
                          <div className='row justify-content-center'>
                          <div class="col-lg img-radius">
                            <img src={img} alt=''/>
                          </div>
                          <div class="col-lg img-radius">
                          <div className='ctn-frm'>
                <h2 class="mb-3">Lest Connect</h2>
                <iframe
                                    aria-label='Register Now'
                                    width="100%"
                                    height="850"
                                    src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                                    frameborder="0" 
                                    title='Register Now'
                                   
                                />
                </div>
                          </div>
                          </div>
            </div>
          </section>
    </main>
    <Enrollaction/>
    <Partnersec/> 
    <Footer/>   
    </div>
  )
}

export default Registernow